<div class="main-view space-y-2 md:space-y-4">
    <app-page-surface-header titleIcon="chart"
        title="Reports"
        subtitle="How each agent's PDs went: how many, how they ended and for how long. Open an agent to see its sessions."
    />

    @if (P.REPORT_LIST | hasPermission) {
    @if (summary) {
    <section aria-label="Summary" class="space-y-1">
        <div class="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
            <div class="panel"><p class="text-sm text-gray-500 dark:text-gray-400">Agents</p><p class="text-2xl font-bold">{{ summary.agents }}</p></div>
            <div class="panel"><p class="text-sm text-gray-500 dark:text-gray-400">Total PDs</p><p class="text-2xl font-bold">{{ summary.total_pds }}</p></div>
            <div class="panel"><p class="text-sm text-gray-500 dark:text-gray-400">Passed</p><p class="text-2xl font-bold text-success">{{ summary.pass_count }}</p></div>
            <div class="panel"><p class="text-sm text-gray-500 dark:text-gray-400">Needs review</p><p class="text-2xl font-bold text-warning">{{ summary.review_count }}</p></div>
            <div class="panel"><p class="text-sm text-gray-500 dark:text-gray-400">Failed</p><p class="text-2xl font-bold text-danger">{{ summary.fail_count }}</p></div>
        </div>
        <p class="text-xs text-gray-500 dark:text-gray-400">
            {{ periodText }}
            @if (unscored > 0) {
            <span class="ml-2">· {{ unscored }} not yet scored</span>
            }
        </p>
    </section>
    }

    @if (hasActiveFilters) {
    <fieldset class="m-0 flex min-w-0 flex-wrap items-center gap-2 border-0 p-0">
        <legend class="sr-only">Active filters</legend>
        @for (chip of filterChips; track chip.key) {
        <span class="inline-flex items-center gap-1 rounded-full bg-primary/10 px-3 py-1 text-xs text-primary">
            {{ chip.label }}: <strong class="font-semibold">{{ chip.text }}</strong>
            <button type="button" class="ml-1 rounded-full px-1 hover:bg-primary/20" [attr.aria-label]="'Remove ' + chip.label + ' filter'" (click)="removeFilter(chip.key)">×</button>
        </span>
        }
        <button type="button" class="text-xs font-medium text-gray-500 underline hover:text-gray-800 dark:text-gray-400" (click)="clearAllFilters()">Clear all</button>
    </fieldset>
    }

    <app-list-module-surface
        [config]="listSurfaceConfig"
        [filters]="listFilters"
        [errorMessage]="listError"
        [loading]="loading"
        [meta]="meta"
        [rowCount]="tableData.length"
        (filtersChange)="onListFiltersChange($event)"
        (pageChange)="onListPageChange($event)"
    >
        <div toolbarFiltersExtra class="relative flex shrink-0 items-center gap-2">
            <label for="reports-product-filter" class="text-xs text-gray-500 dark:text-gray-400">Product</label>
            <select
                id="reports-product-filter"
                [(ngModel)]="selectedType"
                (ngModelChange)="onProductTypeChange()"
                name="reportsFilterType"
                class="form-select w-44 rounded-full bg-white py-2 px-4 text-sm dark:border-[#191e3a] dark:bg-dark"
            >
                <option value="">All products</option>
                @for (pt of productTypes; track pt.name) {
                <option [value]="pt.name">{{ pt.name }}</option>
                }
            </select>
        </div>

        <ng-container toolbarActions>
            @if (P.REPORT_EXPORT | hasPermission) {
            <button
                type="button"
                class="btn inline-flex shrink-0 items-center gap-2 rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-none hover:bg-gray-50 disabled:opacity-40 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5"
                (click)="onExport()"
                [disabled]="loading || !tableData.length"
                title="Export CSV"
            >
                <icon-download class="size-4" />
                Export CSV
            </button>
            }
        </ng-container>

        <div listTable>
            <app-reports-table
                [rows]="tableData"
                [loading]="loading"
                [detailQueryParams]="detailQueryParams"
                [emptyMessage]="hasActiveFilters ? 'No reports match these filters.' : 'No report data found. Adjust filters or deploy agents to see activity here.'"
                (view)="onViewRow($event)"
            />

            @if (hasActiveFilters && !loading && !tableData.length) {
            <div class="py-4 text-center">
                <button type="button" class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium hover:bg-gray-50 dark:border-white/20 dark:hover:bg-white/5" (click)="clearAllFilters()">Clear filters</button>
            </div>
            }
        </div>
    </app-list-module-surface>
    } @else {
    <div
        class="rounded-2xl border border-gray-200 bg-white px-6 py-10 text-center text-sm text-gray-500 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-gray-400"
    >
        You do not have permission to view reports.
    </div>
    }
</div>
